<template>
  <PageContainer>
    <template #header>
      <PageHeader :title="$t('message.apple.title')">
        <template #default>
          <ui-button
            v-if="showAddAccountButton && !isLoading"
            :color="APPLE_COLOR"
            @click="addAccount"
          >
            <AppleIcon color="white" />
            <span class="ml-2">{{ $t("message.apple.loginWithApple") }}</span>
          </ui-button>
        </template>
      </PageHeader>
    </template>
    <div class="content">
      <SectionLoader v-if="isLoading" status :opacity="1" />
      <Header />
      <AccountInfoBoxes v-if="showAddAccountButton" />
      <AccountsContainer :accounts="accounts" @delete-account="deleteAccount" />
    </div>
    <AppleToggleDialog
      v-if="isAppleToggleDialogOpen"
      :title="dialogTitle"
      :subtitle="dialogSubtitle"
      :description="dialogDescription"
      @confirm="setAppleIntegration"
      @close="closeAppleToggleDialog"
    />
  </PageContainer>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import PageContainer from "@/components/ui/PageContainer.vue";
import AccountInfoBoxes from "@/components/AppleMaps/AccountInfoBoxes.vue";
import Header from "@/components/FacebookAccounts/Header.vue";
import AccountsContainer from "@/components/AppleMaps/AccountsContainer.vue";
import AppleIcon from "@/components/ui/Icons/AppleIcon.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import serviceHandler from "@/helpers/handlers/service";
import appleMapsService from "@/services/apple-maps";
import mapIntegrationsService from "@/services/mapIntegrations.js";
const APPLE_COLOR = "#1d1d1f";
export default {
  name: "AppleMapsAccountsList",
  components: {
    PageHeader,
    PageContainer,
    AccountInfoBoxes,
    Header,
    AccountsContainer,
    AppleIcon,
    SectionLoader,
    AppleToggleDialog: () =>
      import("@/components/BusinessAddresses/AppleToggleDialog.vue")
  },
  data() {
    return {
      isLoading: false,
      accounts: [],
      APPLE_COLOR,
      isAppleToggleDialogOpen: false
    };
  },
  computed: {
    showAddAccountButton() {
      return this.accounts.length === 0;
    },
    dialogTitle() {
      return this.$t("message.apple.enableDialog.title");
    },
    dialogSubtitle() {
      return this.$t("message.apple.enableDialog.subtitle");
    },
    dialogDescription() {
      return this.$t("message.apple.enableDialog.description");
    }
  },
  async created() {
    this.isLoading = true;
    if (this.$route.query.code) {
      await this.authorizeAccount();
      this.openAppleToggleDialog();
    }
    await this.getAccountsList();
    this.isLoading = false;
  },
  methods: {
    async authorizeAccount() {
      const { code, state, ...remainingQueries } = this.$route.query;

      this.$router.replace({ query: remainingQueries });
      await appleMapsService.authorizeAccount({ code, state });
    },
    async toggleAppleIntegration(isEnabled) {
      const togglePayload = {
        apple: {
          is_enabled: isEnabled
        }
      };
      await mapIntegrationsService.toggleMapIntegration(togglePayload);
    },
    async setAppleIntegration() {
      await this.toggleAppleIntegration(true);
      await this.getAccountsList();
      this.closeAppleToggleDialog();
      this.$router.push({
        name: "profile-map-settings"
      });
    },
    async addAccount() {
      const url = await serviceHandler(appleMapsService.addAccount());
      window.open(url, "_blank");
    },
    async getAccountsList() {
      this.accounts = await serviceHandler(appleMapsService.getAccounts());
    },
    async deleteAccount(accountId) {
      this.isLoading = true;
      await this.toggleAppleIntegration(false);
      await serviceHandler(appleMapsService.deleteAccount(accountId));
      await this.getAccountsList();

      this.isLoading = false;
    },
    closeAppleToggleDialog() {
      this.isAppleToggleDialogOpen = false;
    },
    openAppleToggleDialog() {
      this.isAppleToggleDialogOpen = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  > * + * {
    margin-top: $spacing * 3;
  }
}
</style>
